module.exports = __webpack_public_path__ + "static/media/gq.6bbb0e76.svg";